/**
 * アコーディオンを開閉する
 */
export function opened01() {
  const jsOpenedButton = document.getElementById('js-opened-button-01');
  const jsOpenedContainer = document.getElementById('js-opened-container-01');
  const fashion = document.getElementById('fashion');

  jsOpenedButton.addEventListener('click', function () {
    jsOpenedButton.classList.toggle('is-active');
    jsOpenedContainer.classList.toggle('is-active');

    const isActive = jsOpenedContainer.classList.contains('is-active');

    if (!isActive) {
      const offset = fashion.offsetTop;

      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      });
    }
  });
}

/**
 * アコーディオンを開閉する
 */
export function opened02() {
  const jsOpenedButton = document.getElementById('js-opened-button-02');
  const jsOpenedContainer = document.getElementById('js-opened-container-02');
  const other = document.getElementById('other');

  jsOpenedButton.addEventListener('click', function () {
    jsOpenedButton.classList.toggle('is-active');
    jsOpenedContainer.classList.toggle('is-active');

    const isActive = jsOpenedContainer.classList.contains('is-active');

    if (!isActive) {
      const offset = other.offsetTop;

      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      });
    }
  });
}

/**
 * 画面幅に応じてアコーディオンの見た目を調整する。一部開いている部分の見え方の整合性を取る。
 */
export function getHeight01() {
  // ① 1番目の要素の高さ PCとSPの両方で必要
  const firstItem = document.getElementById('first-item-01');
  let height = 0;
  height = firstItem.offsetHeight; // ①の高さ

  // ② 2列目の高さ(3カラムの場合、PCでは4番目、SPでは3番目)
  let addItem = 0;

  // ③ flexのgap、要素間の余白
  let gap = 0;

  // PCとSPでカラム数に差があるので、計算する値が異なる
  if (window.matchMedia('(max-width: 767px)').matches) {
    // sp
    addItem = document.getElementById('sp-item-01').offsetHeight; // ② の高さ 3番目の要素の高さ

    // base.scssのremの値を再現する
    const FLEX_GAP = 27; // scssに書かれた値
    const displayWidth = window.innerWidth;
    gap = FLEX_GAP * (displayWidth / 320); // ③の高さ
  } else {
    // pc
    addItem = document.getElementById('pc-item-01').offsetHeight; // ② の高さ 4番目の要素の高さ
    gap = 55; // ③の高さ PCはscssに書かれた値をそのまま
  }

  // アコーディオンの親要素
  const jsOpenedContainer = document.getElementById('js-opened-container-01');

  // ここでheightをリセットしないと、heightが固定されてしまう
  jsOpenedContainer.style.height = 'auto';

  // ① + ② + ③
  jsOpenedContainer.style = `height: ${height + addItem + gap}px`;
}

/**
 * 画面幅に応じてアコーディオンの見た目を調整する。一部開いている部分の見え方の整合性を取る。
 */
export function getHeight02() {
  // ① 1番目の要素の高さ PCとSPの両方で必要
  const firstItem = document.getElementById('first-item-02');
  let height = 0;
  height = firstItem.offsetHeight; // ①の高さ

  // ② 2列目の高さ(3カラムの場合、PCでは4番目、SPでは3番目)
  let addItem = 0;

  // ③ flexのgap、要素間の余白
  let gap = 0;

  // PCとSPでカラム数に差があるので、計算する値が異なる
  if (window.matchMedia('(max-width: 767px)').matches) {
    // sp
    addItem = document.getElementById('sp-item-02').offsetHeight; // ② の高さ 3番目の要素の高さ

    // base.scssのremの値を再現する
    const FLEX_GAP = 27; // scssに書かれた値
    const displayWidth = window.innerWidth;
    gap = FLEX_GAP * (displayWidth / 320); // ③の高さ
  } else {
    // pc
    addItem = document.getElementById('pc-item-02').offsetHeight; // ② の高さ 4番目の要素の高さ
    gap = 55; // ③の高さ PCはscssに書かれた値をそのまま
  }

  // アコーディオンの親要素
  const jsOpenedContainer = document.getElementById('js-opened-container-02');

  // ここでheightをリセットしないと、heightが固定されてしまう
  jsOpenedContainer.style.height = 'auto';

  // ① + ② + ③
  jsOpenedContainer.style = `height: ${height + addItem + gap}px`;
}
